import React, { useState, useMemo } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Grid, Typography, IconButton, makeStyles, Tabs, Tab
} from '@material-ui/core'
import { Close, ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import TourS1 from '../../../assets/images/LG_FilterTour_s1.gif'
import TourS2 from '../../../assets/images/LG_FilterTour_s2.gif'
import TourS3 from '../../../assets/images/LG_FilterTour_s3.gif'
import TourS4 from '../../../assets/images/LG_FilterTour_s4.gif'

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  tabButtonRoot: {
    textTransform: 'none',
    minHeight: 40,
    padding: 0,
    '&:focus': {
      outline: 'none'
    }
  },
  tabWrapper: {
    alignItems: 'flex-start'
  },
  tabSelected: {
    fontWeight: 600,
    color: '#3984f7',
    '&:focus': {
      outline: 'none'
    }
  },
  tabsIndicator: {
    backgroundColor: '#8BB84B'
  },
  iconButton: {
    '&:focus': {
      outline: 'none'
    }
  }
}))

const tourSlide = {
  GENERAL: 1,
  MY_FILTER: 2,
  FAST_FILTER: 3,
  SCHEDULE_FILTER: 4
}

const arrowDir = {
  NEXT: 'next',
  BACK: 'back'
}

const FilterTour = (props) => {
  const { toggleTourOpen = () => {}, localTourItem = '' } = props
  const classes = useStyles()
  const viewed = window.localStorage.getItem(localTourItem)
  const [activeTab, setActiveTab] = useState(tourSlide.GENERAL || 1)

  const handleTabChange = (e, newValue) => {
    setActiveTab(newValue)
  }

  const handleArrowClick = (dir) => {
    let newSlide = null

    if (!dir || !Object.values(arrowDir).includes(dir)) {
      return false
    }

    if (dir === arrowDir.NEXT) {
      newSlide = activeTab + 1
    } else {
      newSlide = activeTab - 1
    }

    setActiveTab(newSlide)
  }

  const tourSlideGif = useMemo(() => ({
    [tourSlide.GENERAL]: TourS1,
    [tourSlide.MY_FILTER]: TourS2,
    [tourSlide.FAST_FILTER]: TourS3,
    [tourSlide.SCHEDULE_FILTER]: TourS4
  }), [])

  const tabContentText = (tabVal) => {
    switch (tabVal) {
      case tourSlide.GENERAL: {
        return (
          <>
            <Typography variant='body1' style={{ fontWeight: 600, textAlign: 'center', color: '#3c3c3c' }}>Use the options in the advanced filter to fine tune your captures.</Typography>
            <Typography variant='subtitle2' style={{ textAlign: 'center' }}>
              Once you have chosen your desired filters you can review your selections to the side of the modal.
              When you are done, hit the 'Apply' button in the bottom right corner.
            </Typography>
          </>
        )
      }
      case tourSlide.MY_FILTER: {
        return (
          <>
            <Typography variant='body1' style={{ fontWeight: 600, textAlign: 'center', color: '#3c3c3c' }}>Use 'My Filters' to return to a set of results.</Typography>
            <Typography variant='subtitle2' style={{ textAlign: 'center' }}>
              Saving a set of filter selections is a great way to return to a specific category of results as often as you need.
              After saving your filter you can find it again easily through the 'My Filters' tab in the top right section of the modal.
              From this tab you can view, edit, and apply the desired filter whenever necessary.
            </Typography>
          </>
        )
      }
      case tourSlide.FAST_FILTER: {
        return (
          <>
            <Typography variant='body1' style={{ fontWeight: 600, textAlign: 'center', color: '#3c3c3c' }}>Quickly access Fast Filters from the captures page.</Typography>
            <Typography variant='subtitle2' style={{ textAlign: 'center' }}>
              If you know, or find later, that your filter will need to be applied frequently, you can select to have it saved as a 'Fast Filter'.
              Fast Filters are displayed in an easy-to-find drop down menu on the main capture page-- reducing the number of steps needed to view your filter.
              You can set this option at the same time you create a saved filter, or add it later from the My Filters tab.
              Unselecting the icon from this tab will also remove it as a Fast Filter if you no longer need to find it as quickly.
            </Typography>
          </>
        )
      }
      case tourSlide.SCHEDULE_FILTER: {
        return (
          <>
            <Typography variant='body1' style={{ fontWeight: 600, textAlign: 'center', color: '#3c3c3c' }}>Schedule Filters to be sent at regular intervals to your email.</Typography>
            <Typography variant='subtitle2' style={{ textAlign: 'center' }}>
              For even greater convenience, saved filters can also be scheduled to deliver a set of results to you through your email.
              A report will be sent to you in a concise pdf or csv format where you can easily view and retain the data returned from your filter as frequently as you desire.
              Use the options provided at the time of creating your filter to set a schedule and rate of recurrence in which you would like to receive the email.
              You can edit these options, or remove the schedule entirely by visiting the My Filters tab, and selecting 'Edit'.
            </Typography>
          </>
        )
      }
      default: return (
        <Typography>Something went wrong. Please close the this modal and try again.</Typography>
      )
    }
  }

  const handleModalClose = () => {
    if (!viewed) {
      window.localStorage.setItem(localTourItem, true)
    }
    setActiveTab(tourSlide.GENERAL)
    toggleTourOpen()
  }

  const headerText = !viewed ? 'Check Out These Features in Advanced Filters!' : 'How do I use Advanced Filters?'

  return (
    <Dialog open={false} onClose={() => handleModalClose()} fullWidth maxWidth='md'>
      <DialogTitle style={{ paddingBottom: 0 }}>
        <Grid container item direction='row'>
          <Grid item xs={8}>
            <Typography
              variant='h5'
              color='primary'
              style={{ fontWeight: 600, color: '#3984f7' }}
            >
              {headerText}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <IconButton
              className={classes.closeButton}
              onClick={() => handleModalClose()}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container item direction='row' style={{ marginTop: '1em', padding: '1em' }}>
          <Grid item xs={2} container direction='column'>
            <Tabs
              orientation='vertical'
              value={activeTab}
              onChange={handleTabChange}
              classes={{ indicator: classes.tabsIndicator }}
            >
              <Tab classes={{ root: classes.tabButtonRoot, wrapper: classes.tabWrapper, selected: classes.tabSelected }} value={tourSlide?.GENERAL} label='Build and Apply' />
              <Tab classes={{ root: classes.tabButtonRoot, wrapper: classes.tabWrapper, selected: classes.tabSelected }} value={tourSlide?.MY_FILTER} label='Save a Filter' />
              <Tab classes={{ root: classes.tabButtonRoot, wrapper: classes.tabWrapper, selected: classes.tabSelected }} value={tourSlide?.FAST_FILTER} label='Fast Filters' />
              <Tab classes={{ root: classes.tabButtonRoot, wrapper: classes.tabWrapper, selected: classes.tabSelected }} value={tourSlide?.SCHEDULE_FILTER} label='Scheduling' />
            </Tabs>
          </Grid>
          <Grid item xs={10} container direction='column' alignItems='center' style={{ paddingLeft: '1em' }}>
            <Grid item container style={{ backgroundImage: `url(${tourSlideGif[activeTab] || tourSlideGif[tourSlide.GENERAL]})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'center', height: '30em' }} />
            <Grid item container direction='row' style={{ marginTop: '1em' }}>
              <Grid item container direction='row' style={{ margin: 'auto' }} justify='flex-start' xs={1}>
                <IconButton
                  size='small'
                  disabled={Boolean(!activeTab || activeTab === tourSlide?.GENERAL)}
                  onClick={() => handleArrowClick(arrowDir?.BACK)}
                  classes={{ root: classes.iconButton }}
                >
                  <ArrowBackIos />
                </IconButton>
              </Grid>
              <Grid item container direction='row' justify='center' xs={10}>
                {tabContentText(activeTab)}
              </Grid>
              <Grid item container direction='row' style={{ margin: 'auto' }} justify='flex-end' xs={1}>
                <IconButton
                  size='small'
                  disabled={Boolean(!activeTab || activeTab === tourSlide?.SCHEDULE_FILTER)}
                  onClick={() => handleArrowClick(arrowDir?.NEXT)}
                  classes={{ root: classes.iconButton }}
                >
                  <ArrowForwardIos />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' style={{ backgroundColor: '#3984f7', color: 'white', fontWeight: 600, textTransform: 'none' }} onClick={() => handleModalClose()}>Got it!</Button>
      </DialogActions>
    </Dialog>
  )
}

export default FilterTour
